import { createPortal } from 'react-dom';

export const ModalPortal = ({ children, isOpen }) => {
  if (!isOpen) return null;
  return createPortal(
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[9999] p-4" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }}>
      {children}
    </div>,
    document.body
  );
};

export default ModalPortal;
